import { AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface DeleteConfirmationProps {
  memberName: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export function DeleteConfirmation({ memberName, onConfirm, onCancel }: DeleteConfirmationProps) {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2 text-amber-600">
        <AlertTriangle className="h-5 w-5" />
        <p className="text-sm">
          سيتم حذف {memberName} وجميع الأفراد المرتبطين به.
        </p>
      </div>
      <div className="flex gap-2">
        <Button variant="destructive" onClick={onConfirm} className="flex-1">
          تأكيد الحذف
        </Button>
        <Button variant="outline" onClick={onCancel} className="flex-1">
          إلغاء
        </Button>
      </div>
    </div>
  );
}